import mdast from 'mdast';

import { DeserializeOptions } from '@lumapps/wrex/serialization/markdown/fromMarkdown/types';

import { createDivider } from '../../utils/createDivider';
import { createHeading } from '../../utils/createHeading';
import { createInlineCode } from '../../utils/createInlineCode';
import { createParagraph } from '../../utils/createParagraph';

export const TYPOGRAPHY_MARKS: DeserializeOptions['marks'] = {
    strong: 'bold',
    emphasis: 'italic',
    delete: 'strikethrough',
};

export const TYPOGRAPHY_ELEMENTS: DeserializeOptions['elements'] = {
    paragraph: {
        convert: (_, children) => createParagraph(children),
    },
    heading: {
        convert: ({ depth }: mdast.Heading, children) => {
            if (!children.length) {
                // Children can't be empty.
                children.push({ text: '' });
            }
            return createHeading(depth, children);
        },
    },
    inlineCode: {
        convert: (node) => createInlineCode([{ text: node.value }]),
    },
    thematicBreak: {
        convert: () => createDivider(),
    },
};
